import { useAuthUser } from './useAuthUser';

export const usePermissions = () => {
  const { user: { meta: { permissions = [] } = {} } = {} } = useAuthUser();

  const hasPermission = (permission: string) => {
    return permissions.some((p) => p.name === permission);
  };

  return {
    hasPermission,
  };
};
